import React, { useEffect, useState } from 'react';
import { useSelectedOrgUnit, useUserBrands } from '@retail/app/stores/selected-context';
import ReactGA from 'react-ga4';
import { mgPrisConfig } from '@retail/mgpris/config';
import { useLocation } from 'react-router';
import { getStoredCalculusView } from '@retail/calculus/hooks';
import { useAvailableCalculusAreas } from '@retail/calculus/context';
import { CalculusTab } from '@retail/calculus/types';
import { useConsumerType } from '@retail/sanity/hooks';
import { useFetchMe } from '@retail/users/data-access';
import { hashUserId, setUserProperties } from '@shared/utils';

export const AnalyticsSetupContainer: React.FC = () => {
  const [hasSetGADimensions, setHasSetGaDimensions] = useState<boolean>(false);
  const { selectedOrgUnitAssortment } = useSelectedOrgUnit();
  const { selectedBrand } = useUserBrands();
  const location = useLocation();
  const { data: user } = useFetchMe({ refetchOnWindowFocus: false });
  const [hashedUserId, setHashedUserId] = useState<string>();
  const userGroup = useConsumerType();
  const combinedViewAvailable = useAvailableCalculusAreas().includes(CalculusTab.ALL_CONDITIONS);

  useEffect(() => {
    if (user) hashUserId(user.userId).then(setHashedUserId);
  }, [user]);

  useEffect(() => {
    if (
      mgPrisConfig.gaMeasurementId &&
      !hasSetGADimensions &&
      !user?.isSuperUser &&
      selectedBrand &&
      selectedOrgUnitAssortment &&
      hashedUserId
    ) {
      ReactGA.initialize(mgPrisConfig.gaMeasurementId, {
        gtagOptions: {
          user_id: hashedUserId,
          mg_app: 'mgpris',
          mg_brand: selectedBrand.name,
          mg_org_unit_name: selectedOrgUnitAssortment.name,
        },
      });
      setUserProperties({
        conditions_view: combinedViewAvailable ? getStoredCalculusView() : 'unavailable',
        user_group: userGroup,
      });
      setHasSetGaDimensions(true);
      ReactGA.event('page_view');
    }
  }, [
    hasSetGADimensions,
    user,
    selectedBrand,
    selectedOrgUnitAssortment,
    hashedUserId,
    userGroup,
    combinedViewAvailable,
  ]);

  useEffect(() => {
    if (hasSetGADimensions) {
      ReactGA.event('page_view');
    }
  }, [location, hasSetGADimensions]);

  return null;
};
